import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";

export function colorForShipmentState(state: ShipmentState): string {
  switch (state) {
    case ShipmentState.Quoted:
      return "var(--color-very-light-gray)";
    case ShipmentState.QuoteRequested:
      return "var(--color-very-light-gray)";
    case ShipmentState.BookingConfirmed:
      return "var(--color-gold)";
    case ShipmentState.BookingRequested:
      return "var(--color-gold)";
    case ShipmentState.BookingFailed:
      return "var(--color-gold)";
    case ShipmentState.InTransit:
      return "var(--color-brand)";
    case ShipmentState.Delivered:
      return "var(--color-dark-green)";
    case ShipmentState.OnHold:
      return "var(--color-mid-gray)";
    case ShipmentState.Cancelled:
      return "var(--color-foreground)";
    case ShipmentState.Lost:
      return "var(--color-foreground)";
  }
}
